import {getUUID} from "../utils/utils";
import {CONFIG, SESSION_ID} from "./config";
import axios from "axios";
import store from "./store";
import {setLastResponseTimeAction} from "../actions/chat-common-actions";

const service = axios.create({
    timeout: 60000,
});

// service.defaults.baseURL = CONFIG.MFE_PUBLIC_PATH
service.defaults.baseURL = CONFIG.GATEWAY_PATH
console.log("this is come from openshift 4.x route")
service.defaults.withCredentials = true
service.interceptors.request.use(
    (config) => {
        config.headers =  config.headers
                .set("Access-Control-Allow-Credentials", "true")
                .set("Access-Control-Allow-Methods", "POST, GET, PUT, DELETE, OPTION")
                .set("Access-Control-Allow-Headers", "Content-Type")
                .set("x-chatbot-type", "EXTERNAL")
                .set("x-correlation-id", getUUID())
                .set("x-source-country", "SG")
                .set("x-source-app", "CHATBOT_EMMA")
                .set("x-source-date-time", new Date().toISOString())
                .set("x-source-id", "INB")
                .set("x-user-dept", "CHATBOT_EMMA")
                .set("x-channel-id", (sessionStorage.getItem("channelId") ? sessionStorage.getItem("channelId") : CONFIG.CHANNEL_ID) ?? "")
                .set("x-conversation-session-id", (sessionStorage.getItem(SESSION_ID) ? sessionStorage.getItem(SESSION_ID) : "") ?? "");

        if (sessionStorage.getItem("opToken")) {
            config.headers = config.headers
                .set("x-acc-op", (sessionStorage.getItem("opToken") ? sessionStorage.getItem("opToken") : "") ?? "");
        }
        if (config.url && config.url.indexOf("/conversations/detectIntent") !== -1) {
            sessionStorage.setItem("needNotify", "true");
            localStorage.setItem("needShowFeedback", "false");
        }
        return config;
    },
    (error) => {
        Promise.reject(error);
    }
);
service.interceptors.response.use(
    (response) => {
        store.dispatch(setLastResponseTimeAction());
        localStorage.setItem("lastResponseTime", new Date().getTime().toString());
        if (response?.status?.toString().startsWith("2")) {
            if (response.headers["x-acc-op"]) {
                sessionStorage.setItem("opToken", response.headers["x-acc-op"]);
            }
            return response.data;
        }
    },
    (error) => {
        store.dispatch(setLastResponseTimeAction());
        localStorage.setItem("lastResponseTime", new Date().getTime().toString());
        return error.response;
    }
);
export default service;